import { defineStore } from 'pinia'
import { reactive, readonly } from 'vue'

interface IExchangeRates {
	[key: string]: number
}

interface IExchangeRatesStoreState {
	exchangeRates: IExchangeRates
}

interface IExchangeRatesStore {
	readonly state: IExchangeRatesStoreState
	setExchangeRates: (exchangeRates: IExchangeRates) => void
	getExchangeRates: ComputedRef<IExchangeRates>
	getExchangeRateForCurrency: (currency: string) => number
	getExchangeRate: (currency: string) => number
}

export const useCurrenciesStore = defineStore('currenciesStore', (): IExchangeRatesStore => {
	const _state = reactive<IExchangeRatesStoreState>({
		exchangeRates: {},
	})

	const setExchangeRates = (exchangeRates: IExchangeRates): void => {
		_state.exchangeRates = exchangeRates
	}

	const getExchangeRates = computed(() => {
		return _state.exchangeRates
	})

	const getExchangeRateForCurrency = (currency: string) => {
		return _state.exchangeRates[currency]
	}

	const getExchangeRate = (currency: string) => {
		return _state.exchangeRates?.[currency]
	}

	return {
		state: readonly(_state),
		setExchangeRates,
		getExchangeRates,
		getExchangeRateForCurrency,
		getExchangeRate,
	}
})
